import { Flex } from 'antd';
import React from 'react';

type SentimentLabel = 'positive' | 'negative' | 'neutral';

interface SentimentBlockProps {
  sentimentLabel: SentimentLabel | string;
}

const sentimentConfig: Record<string, { color: string; label: string }> = {
  positive: { color: 'var(--green-900)', label: 'Positive' },
  negative: { color: 'var(--danger)', label: 'Negative' },
  neutral: { color: 'var(--light-blue)', label: 'Neutral' },
};

export const SentimentLabel: React.FC<SentimentBlockProps> = ({
  sentimentLabel,
}) => {
  const key = sentimentLabel?.toLowerCase();
  const { color, label } = sentimentConfig[key] || {
    label: sentimentLabel,
    color: 'var(--gray-600)',
  };

  if (!sentimentLabel) return null;

  return (
    <Flex align='center' gap={8}>
      <span
        style={{
          display: 'inline-block',
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: color,
        }}
      />
      <span className='zl-heading-12'>{label}</span>
    </Flex>
  );
};
